import React from 'react';
import { useIntl } from 'react-intl';
import { useWindowSize } from '@react-hook/window-size';

import { useTheme } from '../../ThemeContext';

import Helmet from '../../components/Helmet';
import SignInPanel from '../../components/SignInPanel';

import IMAGE_SIGN_BACKGROUND from '../../assets/Images/SignBackground.jpg';

import {
  Section,
  Wrapper,
  Content,
  Imagebox,
  Image,
  Footer,
} from './SignInPage.style';
import { Breakpoints } from '../../assets/Variables.style';

const SignInPage = () => {
  const [width] = useWindowSize();
  const intl = useIntl();
  const theme = useTheme();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: 'PAGE_TITLE.SIGN_IN' })} />
      <Section>
        <Wrapper theme={theme.sign.wrapper.default}>
          <Content>
            <SignInPanel />
          </Content>
          <Footer theme={theme.sign.footer.default}>
            By signing in, you accept{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Privacy policy
            </a>{' '}
            <br />
            (including Use of Cookies and Other
            <br /> Technologies) and{' '}
            <a
              href='http://www.bine.world'
              target='_blank'
              rel='noopener noreferrer'
            >
              Terms of use
            </a>
          </Footer>
        </Wrapper>
        {width > Breakpoints.lg ? (
          <Wrapper theme={theme.sign.wrapper.alternative}>
            <Imagebox>
              <Image src={IMAGE_SIGN_BACKGROUND} alt='' />
            </Imagebox>
          </Wrapper>
        ) : (
          ''
        )}
      </Section>
    </>
  );
};

export default SignInPage;
